<template>
  <!-- 底部组件 -->
  <footer class="footer-container">
    <div class="friend-link-wrapper" v-if="linkList.length > 0">
      <div class="link-header">
        <i class="el-icon-link" style="color: #409eff; font-size: 26px"></i>
        <h3 class="link-title">{{ $t("footer.linkTitle") }}</h3>
      </div>

      <div class="link-list">
        <a
          v-for="(item, index) in linkList"
          :key="index"
          :href="item.fdPath"
          target="_blank"
          class="link-item"
        >
          {{ getLocalizedTitle(item.fdTitle) }}
        </a>
      </div>
    </div>
    <div class="footer-nav">
      <a href="/" class="nav-item">{{ $t("footer.nav.home") }}</a>
      <span>|</span>
      <!-- <a href="#" class="nav-item">{{ $t("footer.nav.about") }}</a>
      <span>|</span> -->
      <router-link to="/group-introduction" class="nav-item">{{
        $t("nav.groupIntroduction")
      }}</router-link>
      <span>|</span>
      <!-- <a href="#" class="nav-item">{{ $t("footer.nav.contact") }}</a> -->
      <router-link to="/about-us" class="nav-item">{{
        $t("footer.nav.contact")
      }}</router-link>
      <span>|</span>
      <router-link to="/news-center" class="nav-item">{{
        $t("nav.newsCenter")
      }}</router-link>
      <span>|</span>
      <!-- <a href="#" class="nav-item">{{ $t("footer.nav.download") }}</a> -->
      <router-link to="/download-center" class="nav-item">{{
        $t("footer.nav.download")
      }}</router-link>
      <!-- <span>|</span>
      <a href="#" class="nav-item">{{ $t("footer.nav.rss") }}</a> -->
    </div>

    <!-- 联系信息 -->
    <div class="contact-info">
      <p>
        {{ $t("footer.contact.address")
        }}{{ $t("footer.contact.addressValue") }}
      </p>

      <p>
        {{ $t("footer.contact.email") }}{{ $t("footer.contact.emailValue") }}
      </p>
    </div>

    <div class="copyright">{{ $t("footer.copyright") }}</div>

    <!-- 备案信息：国际化 -->
    <div class="record-info" @click="gobeian">{{ $t("footer.record") }}</div>
  </footer>
</template>

<script>
import { getLink } from "@/api/index";
export default {
  name: "AppFooter",
  data() {
    return {
      linkList: [],
    };
  },
  mounted() {
    // 获取友情链接
    getLink().then((res) => {
      console.log("友情链接数据：", res);
      this.linkList = res;
    });
  },
  methods: {
    gobeian() {
      window.open("https://beian.miit.gov.cn/");
    },
    getLocalizedTitle(titleStr) {
      // 异常处理：如果标题字符串为空/不是字符串，返回默认提示
      if (!titleStr || typeof titleStr !== "string") {
        return "暂无标题";
      }
      try {
        // 解析JSON字符串为数组
        const titleList = JSON.parse(titleStr);
        // 匹配当前语言的标题（优先匹配，无则取简体中文）
        const currentLang = this.$i18n.locale;
        const matchedItem = titleList.find(
          (item) => item.fd_language_sign === currentLang,
        );
        // 找不到当前语言时，取简体中文（zh-cn）
        const fallbackItem = titleList.find(
          (item) => item.fd_language_sign === "zh-cn",
        );
        // 返回对应值，无则返回默认提示
        return matchedItem?.value || fallbackItem?.value || "暂无标题";
      } catch (e) {
        // JSON解析失败时的容错
        console.error("解析多语言标题失败：", e);
        return "暂无标题";
      }
    },
  },
};
</script>

<style scoped>
/* 核心新增：清除浮动 + 兜底层级，防止被覆盖 */
.footer-container {
  background-color: #96731f;
  color: #fff;
  padding: 20px;
  font-size: 14px;
  text-align: center;
  /* 关键1：清除所有浮动影响 */
  clear: both;
  /* 关键2：兜底层级，确保不被覆盖（relative不脱离文档流） */
  position: relative;
  z-index: 10;
  /* 关键3：确保宽度100%，无溢出 */
  width: 100%;
  box-sizing: border-box;
}

/* 友情链接容器 */
.friend-link-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  font-size: 14px;
  color: #333;
  text-align: left;
  box-sizing: border-box;
}

/* 标题区域 */
.link-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: flex-start;
}

.link-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: #fff;
  text-align: left;
}

/* 链接列表 */
.link-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px 25px;
  margin: 10px 0;
}

/* 单个链接样式 */
.link-item {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s ease;
  text-align: left;
}

.link-item:hover {
  color: #e6b800;
  text-decoration: underline;
}

/* 顶部导航栏 */
.footer-nav {
  margin-bottom: 15px;
  /* 新增：防止导航栏溢出 */
  box-sizing: border-box;
}

.nav-item {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s;
}

.nav-item:hover {
  color: #f1c40f;
}

.footer-nav span {
  margin: 0 5px;
  color: #fff;
}

/* 联系信息区域 */
.contact-info {
  margin-bottom: 10px;
  line-height: 1.6;
  box-sizing: border-box;
}

/* 版权信息 */
.copyright {
  font-size: 12px;
  margin-bottom: 5px;
}

/* 备案信息 */
.record-info {
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;
  cursor: pointer;
}

/* RSS按钮 */
.rss-btn {
  display: inline-block;
  background-color: #f39c12;
  color: #fff;
  padding: 3px 8px;
  text-decoration: none;
  font-size: 12px;
}

.rss-btn:hover {
  background-color: #e67e22;
}

/* 响应式适配（清理无效样式） */
@media (max-width: 992px) {
  .friend-link-wrapper {
    padding: 20px 15px;
  }
}

@media (max-width: 768px) {
  .friend-link-wrapper {
    text-align: center;
  }
  .link-header {
    justify-content: center;
  }
  .link-list {
    justify-content: center;
  }
  .link-item {
    text-align: center;
  }
}

@media (max-width: 576px) {
  .footer-container {
    padding: 15px 10px;
  }
  .footer-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px 10px;
  }
  .footer-nav span {
    display: none; /* 小屏隐藏分隔符，更美观 */
  }
}
</style>
